export default __webpack_public_path__ + "fonts/rectangle.fcd242b36c1f8f73c82d40ebab885675.png";